import React from "react";

export const LOGO = "/brand/logo-badge.png";

// Keys Event Center badge logo (transparent).
export default function Logo({ className = "h-10" }) {
  return <img src={LOGO} alt="Keys Event Center" className={className} data-testid="site-logo" />;
}
